import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

export const fetchBannerData = createAsyncThunk(
    "banner/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const response = await request({
                endpoint: "/user/banner",
                method: "GET",
            });

            console.log("Fetch BannerData Response:", response);

            if (!response.success) {
                return rejectWithValue(response.message || "Failed to fetch banner data.");
            }

            return response.data.banners;
        } catch ({ error }) {
            console.error("Error fetching banner data:", error);
            return rejectWithValue(error.message || "An unexpected error occurred while fetching banner data.");
        }
    }
);

const initialState = {
    banners: null,
    loading: false,
    error: null,
};

const bannerSlice = createSlice({
    name: 'banner',
    initialState,
    reducers: {
        addBanners: (state, action) => {
            state.banners = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBannerData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBannerData.fulfilled, (state, action) => {
                state.loading = false;
                state.banners = action.payload;
            })
            .addCase(fetchBannerData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export const { addBanners } = bannerSlice.actions;
export default bannerSlice.reducer;